/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CommissionRateSaveReqVo,
  ResponseBoolean,
  ResponseCommissionRateInitRespVo,
  ResponseCommissionRateViewRespVo,
  ResponseCommissionSettleDetailRespVo,
  ResponsePageDataCommissionInviteStatsPageItemVo,
  ResponsePageDataCommissionPartnerDetailPageItemVo,
  ResponsePageDataCommissionPartnerPageItemVo,
  ResponsePageDataCommissionSettlePageItemVo,
  ResponsePageDataRecommendCodeBindPageItemVo,
  ResponseRecommendCodeBindDetailRespVo,
} from '../models/index';
import {
    CommissionRateSaveReqVoFromJSON,
    CommissionRateSaveReqVoToJSON,
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponseCommissionRateInitRespVoFromJSON,
    ResponseCommissionRateInitRespVoToJSON,
    ResponseCommissionRateViewRespVoFromJSON,
    ResponseCommissionRateViewRespVoToJSON,
    ResponseCommissionSettleDetailRespVoFromJSON,
    ResponseCommissionSettleDetailRespVoToJSON,
    ResponsePageDataCommissionInviteStatsPageItemVoFromJSON,
    ResponsePageDataCommissionInviteStatsPageItemVoToJSON,
    ResponsePageDataCommissionPartnerDetailPageItemVoFromJSON,
    ResponsePageDataCommissionPartnerDetailPageItemVoToJSON,
    ResponsePageDataCommissionPartnerPageItemVoFromJSON,
    ResponsePageDataCommissionPartnerPageItemVoToJSON,
    ResponsePageDataCommissionSettlePageItemVoFromJSON,
    ResponsePageDataCommissionSettlePageItemVoToJSON,
    ResponsePageDataRecommendCodeBindPageItemVoFromJSON,
    ResponsePageDataRecommendCodeBindPageItemVoToJSON,
    ResponseRecommendCodeBindDetailRespVoFromJSON,
    ResponseRecommendCodeBindDetailRespVoToJSON,
} from '../models/index';

export interface CommissionBindDetailGetRequest {
    userId: number;
    partnerUserId: number;
}

export interface CommissionBindPageGetRequest {
    userId: number;
    currentPage?: number;
    pageSize?: number;
    startDate?: string;
    endDate?: string;
    userCode?: string;
    recommendCode?: string;
}

export interface CommissionInviteStatsPageGetRequest {
    currentPage?: number;
    pageSize?: number;
    year?: number;
    gradeId?: number;
    userName?: string;
    userCode?: string;
}

export interface CommissionPartnerDetailPageGetRequest {
    currentPage?: number;
    pageSize?: number;
    gradeId?: number;
    userName?: string;
    userCode?: string;
    recommendCode?: string;
    mobileNo?: string;
}

export interface CommissionPartnerPageGetRequest {
    currentPage?: number;
    pageSize?: number;
    year?: number;
    gradeId?: number;
    userName?: string;
    userCode?: string;
    recommendCode?: string;
}

export interface CommissionRateInitGetRequest {
    recommendCodeIds: Array<number>;
}

export interface CommissionRateSavePostRequest {
    commissionRateSaveReqVo?: CommissionRateSaveReqVo;
}

export interface CommissionRateViewRecommendCodeIdGetRequest {
    recommendCodeId: number;
}

export interface CommissionSettleDetailExportGetRequest {
    userId: number;
    year: number;
    month: number;
}

export interface CommissionSettleDetailGetRequest {
    userId: number;
    year: number;
    month: number;
}

export interface CommissionSettleFilePostRequest {
    userId: number;
    year: number;
    month: number;
    file: Blob;
}

export interface CommissionSettlePageGetRequest {
    currentPage?: number;
    pageSize?: number;
    year?: number;
    gradeId?: number;
    userName?: string;
    userCode?: string;
}

/**
 * 
 */
export class CommissionControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 推荐码绑定记录--查看明细对话框初始值（展示某个邀新会员通过当前合作会员推荐码产生的全部佣金明细，按订单一行；含各附加服务金额与分成、小计与业绩合计）
     */
    async commissionBindDetailGetRaw(requestParameters: CommissionBindDetailGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseRecommendCodeBindDetailRespVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling commissionBindDetailGet().'
            );
        }

        if (requestParameters['partnerUserId'] == null) {
            throw new runtime.RequiredError(
                'partnerUserId',
                'Required parameter "partnerUserId" was null or undefined when calling commissionBindDetailGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['partnerUserId'] != null) {
            queryParameters['partnerUserId'] = requestParameters['partnerUserId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/commission/bind/detail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseRecommendCodeBindDetailRespVoFromJSON(jsonValue));
    }

    /**
     * 
     * 推荐码绑定记录--查看明细对话框初始值（展示某个邀新会员通过当前合作会员推荐码产生的全部佣金明细，按订单一行；含各附加服务金额与分成、小计与业绩合计）
     */
    async commissionBindDetailGet(requestParameters: CommissionBindDetailGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseRecommendCodeBindDetailRespVo> {
        const response = await this.commissionBindDetailGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 推荐码绑定记录--分页查询通过当前合作会员推荐码注册的邀新会员及其出库完成数/结算金额/佣金金额（限检索当前userId拥有的推荐码；开始/结束日期针对推荐码绑定日=user.createTime）
     */
    async commissionBindPageGetRaw(requestParameters: CommissionBindPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataRecommendCodeBindPageItemVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling commissionBindPageGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['recommendCode'] != null) {
            queryParameters['recommendCode'] = requestParameters['recommendCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/commission/bind/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataRecommendCodeBindPageItemVoFromJSON(jsonValue));
    }

    /**
     * 
     * 推荐码绑定记录--分页查询通过当前合作会员推荐码注册的邀新会员及其出库完成数/结算金额/佣金金额（限检索当前userId拥有的推荐码；开始/结束日期针对推荐码绑定日=user.createTime）
     */
    async commissionBindPageGet(requestParameters: CommissionBindPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataRecommendCodeBindPageItemVo> {
        const response = await this.commissionBindPageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 邀新注册统计--分页查询合作会员及其邀新会员的月度出库单数/业绩/分成（分页按合作会员；筛选作用于合作会员；仅返回有佣金记录的月份）
     */
    async commissionInviteStatsPageGetRaw(requestParameters: CommissionInviteStatsPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataCommissionInviteStatsPageItemVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        if (requestParameters['gradeId'] != null) {
            queryParameters['gradeId'] = requestParameters['gradeId'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/commission/invite/stats/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataCommissionInviteStatsPageItemVoFromJSON(jsonValue));
    }

    /**
     * 
     * 邀新注册统计--分页查询合作会员及其邀新会员的月度出库单数/业绩/分成（分页按合作会员；筛选作用于合作会员；仅返回有佣金记录的月份）
     */
    async commissionInviteStatsPageGet(requestParameters: CommissionInviteStatsPageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataCommissionInviteStatsPageItemVo> {
        const response = await this.commissionInviteStatsPageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 合作会员管理--分页查询会员分成明细（一行一个会员，推荐码/适用日期/结算信息以列表返回；登录日期为最后登录时间）
     */
    async commissionPartnerDetailPageGetRaw(requestParameters: CommissionPartnerDetailPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataCommissionPartnerDetailPageItemVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['gradeId'] != null) {
            queryParameters['gradeId'] = requestParameters['gradeId'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['recommendCode'] != null) {
            queryParameters['recommendCode'] = requestParameters['recommendCode'];
        }

        if (requestParameters['mobileNo'] != null) {
            queryParameters['mobileNo'] = requestParameters['mobileNo'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/commission/partner/detail/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataCommissionPartnerDetailPageItemVoFromJSON(jsonValue));
    }

    /**
     * 
     * 合作会员管理--分页查询会员分成明细（一行一个会员，推荐码/适用日期/结算信息以列表返回；登录日期为最后登录时间）
     */
    async commissionPartnerDetailPageGet(requestParameters: CommissionPartnerDetailPageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataCommissionPartnerDetailPageItemVo> {
        const response = await this.commissionPartnerDetailPageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 合作会员管理--分页查询合作会员列表（邀新注册人数、累计分成按所选年份统计，累计分成仅含已结算佣金）
     */
    async commissionPartnerPageGetRaw(requestParameters: CommissionPartnerPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataCommissionPartnerPageItemVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        if (requestParameters['gradeId'] != null) {
            queryParameters['gradeId'] = requestParameters['gradeId'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['recommendCode'] != null) {
            queryParameters['recommendCode'] = requestParameters['recommendCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/commission/partner/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataCommissionPartnerPageItemVoFromJSON(jsonValue));
    }

    /**
     * 
     * 合作会员管理--分页查询合作会员列表（邀新注册人数、累计分成按所选年份统计，累计分成仅含已结算佣金）
     */
    async commissionPartnerPageGet(requestParameters: CommissionPartnerPageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataCommissionPartnerPageItemVo> {
        const response = await this.commissionPartnerPageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 分成比例设置--对话框初始化数据（会员推荐码信息基于所选推荐码id，可选项为billType=3账单可选的附加服务，全部仓库并集）
     */
    async commissionRateInitGetRaw(requestParameters: CommissionRateInitGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCommissionRateInitRespVo>> {
        if (requestParameters['recommendCodeIds'] == null) {
            throw new runtime.RequiredError(
                'recommendCodeIds',
                'Required parameter "recommendCodeIds" was null or undefined when calling commissionRateInitGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['recommendCodeIds'] != null) {
            queryParameters['recommendCodeIds'] = requestParameters['recommendCodeIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/commission/rate/init`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCommissionRateInitRespVoFromJSON(jsonValue));
    }

    /**
     * 
     * 分成比例设置--对话框初始化数据（会员推荐码信息基于所选推荐码id，可选项为billType=3账单可选的附加服务，全部仓库并集）
     */
    async commissionRateInitGet(requestParameters: CommissionRateInitGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCommissionRateInitRespVo> {
        const response = await this.commissionRateInitGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 分成比例设置--保存（同一份分成配置批量应用到所有勾选推荐码，整体覆盖旧配置；适用日期未传时保持原值）
     */
    async commissionRateSavePostRaw(requestParameters: CommissionRateSavePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/commission/rate/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CommissionRateSaveReqVoToJSON(requestParameters['commissionRateSaveReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 分成比例设置--保存（同一份分成配置批量应用到所有勾选推荐码，整体覆盖旧配置；适用日期未传时保持原值）
     */
    async commissionRateSavePost(requestParameters: CommissionRateSavePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.commissionRateSavePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 分成比例设置--查看单个推荐码的分成比例信息
     */
    async commissionRateViewRecommendCodeIdGetRaw(requestParameters: CommissionRateViewRecommendCodeIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCommissionRateViewRespVo>> {
        if (requestParameters['recommendCodeId'] == null) {
            throw new runtime.RequiredError(
                'recommendCodeId',
                'Required parameter "recommendCodeId" was null or undefined when calling commissionRateViewRecommendCodeIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/commission/rate/view/{recommendCodeId}`.replace(`{${"recommendCodeId"}}`, encodeURIComponent(String(requestParameters['recommendCodeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCommissionRateViewRespVoFromJSON(jsonValue));
    }

    /**
     * 
     * 分成比例设置--查看单个推荐码的分成比例信息
     */
    async commissionRateViewRecommendCodeIdGet(requestParameters: CommissionRateViewRecommendCodeIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCommissionRateViewRespVo> {
        const response = await this.commissionRateViewRecommendCodeIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 分成结算--单元格明细Excel下载（列结构与明细对话框列表一致，但订单编号列仅含订单编号、不含下单会员名；服务列单格为\"金额 (分成)\"；文件名：会员名_分成结算明细_yyyy-MM.xlsx）
     */
    async commissionSettleDetailExportGetRaw(requestParameters: CommissionSettleDetailExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling commissionSettleDetailExportGet().'
            );
        }

        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling commissionSettleDetailExportGet().'
            );
        }

        if (requestParameters['month'] == null) {
            throw new runtime.RequiredError(
                'month',
                'Required parameter "month" was null or undefined when calling commissionSettleDetailExportGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/commission/settle/detail/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     * 分成结算--单元格明细Excel下载（列结构与明细对话框列表一致，但订单编号列仅含订单编号、不含下单会员名；服务列单格为\"金额 (分成)\"；文件名：会员名_分成结算明细_yyyy-MM.xlsx）
     */
    async commissionSettleDetailExportGet(requestParameters: CommissionSettleDetailExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.commissionSettleDetailExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 分成结算--单元格明细对话框初始值（聚合该会员全部推荐码当月佣金，按订单一行；含银行信息，已结清时返回结算文件信息）
     */
    async commissionSettleDetailGetRaw(requestParameters: CommissionSettleDetailGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCommissionSettleDetailRespVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling commissionSettleDetailGet().'
            );
        }

        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling commissionSettleDetailGet().'
            );
        }

        if (requestParameters['month'] == null) {
            throw new runtime.RequiredError(
                'month',
                'Required parameter "month" was null or undefined when calling commissionSettleDetailGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/commission/settle/detail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCommissionSettleDetailRespVoFromJSON(jsonValue));
    }

    /**
     * 
     * 分成结算--单元格明细对话框初始值（聚合该会员全部推荐码当月佣金，按订单一行；含银行信息，已结清时返回结算文件信息）
     */
    async commissionSettleDetailGet(requestParameters: CommissionSettleDetailGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCommissionSettleDetailRespVo> {
        const response = await this.commissionSettleDetailGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 分成结算--保存结算文件（上传即结算：上传图片凭证并将该会员当月全部未结算佣金置为已结算；仅支持图片格式）
     */
    async commissionSettleFilePostRaw(requestParameters: CommissionSettleFilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling commissionSettleFilePost().'
            );
        }

        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling commissionSettleFilePost().'
            );
        }

        if (requestParameters['month'] == null) {
            throw new runtime.RequiredError(
                'month',
                'Required parameter "month" was null or undefined when calling commissionSettleFilePost().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling commissionSettleFilePost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/commission/settle/file`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 分成结算--保存结算文件（上传即结算：上传图片凭证并将该会员当月全部未结算佣金置为已结算；仅支持图片格式）
     */
    async commissionSettleFilePost(requestParameters: CommissionSettleFilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.commissionSettleFilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 分成结算--分页查询合作会员按月聚合的出库单数/业绩/分成（仅返回有佣金记录的月份；当月存在未结算即待结清）
     */
    async commissionSettlePageGetRaw(requestParameters: CommissionSettlePageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataCommissionSettlePageItemVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        if (requestParameters['gradeId'] != null) {
            queryParameters['gradeId'] = requestParameters['gradeId'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/commission/settle/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataCommissionSettlePageItemVoFromJSON(jsonValue));
    }

    /**
     * 
     * 分成结算--分页查询合作会员按月聚合的出库单数/业绩/分成（仅返回有佣金记录的月份；当月存在未结算即待结清）
     */
    async commissionSettlePageGet(requestParameters: CommissionSettlePageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataCommissionSettlePageItemVo> {
        const response = await this.commissionSettlePageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
